<template>
  <div :class="getClass">
    <small>
    <font-awesome-icon icon="globe" />
    &nbsp;
    <select v-model="$i18n.locale" @change="onChange($event)">
      <option v-for="(lang, i) in $store.state.main.langs" :key="`Lang${i}`" :value="lang">{{ getLanguage(lang) }}</option>
    </select>
    </small>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    leftAlign: {
        type: Boolean,
        required: false,
        default: false
    }
  },  
  mounted() {
    this.$i18n.locale = this.$store.state.main.selectedLocale;  
  },
  computed: {
    getClass() {
      if (this.leftAlign) {
        return "LocaleChanger;";
      } else {
        return "LocaleChanger; text-right";
      }
    }
  },
  methods: {
    getLanguage(lang) {
      // Hard coded for now for simplicity
      switch (lang) {
        case 'en':
          return 'ENGLISH';
        case 'fi':
          return 'SUOMI';
        case 'de':
          return 'DEUTSCH';
        case 'sv':
          return 'SVENSKA';
        case 'ko':
          return '한국어';
        default:
          return lang;
      }
    },
    onChange(event) {
        this.$store.commit({
          type: "setSelectedLocale",
          selectedLocale: event.target.value
        });
    }
  }
}
</script>

<style scoped>
.LocaleChanger {
  display: flex;
  height: 52px;
  width: fit-content;
  min-width: 150px;
  padding: 12px;
  padding-left: 12px;
  align-items: center;
  gap: 12px;
  border-radius: 56px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  background: #FFF;
}

.text-right {
  justify-content: flex-end;
  padding-right: 12px;
}
</style>
